import { DatePicker as OrbitBase } from '../../original/js/components/datepicker';
import ElementHelpers from '../../original/js/libraries/element-helpers';
import { German } from 'flatpickr/dist/l10n/de';
import { Dutch } from 'flatpickr/dist/l10n/nl';
import { French } from 'flatpickr/dist/l10n/fr';
import { Portuguese } from 'flatpickr/dist/l10n/pt';
import { Spanish } from 'flatpickr/dist/l10n/es';
import { Hungarian } from 'flatpickr/dist/l10n/hu';
import { Romanian } from 'flatpickr/dist/l10n/ro';
import { Italian } from 'flatpickr/dist/l10n/it';
import { Greek } from 'flatpickr/dist/l10n/gr';

/**
 * date-picker.js
 * set date picker on an input field
 */

export class DatePicker extends OrbitBase {
  constructor(element) {
    super(element)

    this.language = this.input.dataset.rsDatepickerLanguage;
    this.disableFutureDates = this.input.dataset.rsDatepickerDisableFutureDates;
    this.disablePastDates = this.input.dataset.rsDatepickerDisablePastDates;

    if (this.disableFutureDates === "true") {
      this.maxDate = 'today'
    }

    if (this.disablePastDates === "true") {
      this.minDate = 'today'
    }

    this.setExtendedLocalisation()
    
    // Initialize datepicker with new settings. DON`T REMOVE IT.
    const options = this.flatOptions()

		// Create flatpickr instance.
    this.input.flatpickr(
      options
    );
  }

  // Мръсен хак!!! Remove default date picker init. DON`T REMOVE IT.
  createFlatDatePicker() {
    // Keep it empty !!!
	}
  
  /**
   * Set language/localisation for instance
   */
  setExtendedLocalisation() {

    switch (this.language) {
      case 'de':
        this.locale = Object.assign(this.locale, German);             
        break;

      case 'nl':
        this.locale = Object.assign(this.locale, Dutch);             
        break;

      case 'fr':
        this.locale = Object.assign(this.locale, French);            
        break;

      case 'pt':
        this.locale = Object.assign(this.locale, Portuguese);        
        break;

      case 'es':
        this.locale = Object.assign(this.locale, Spanish);        
        break;

      case 'hu':
        this.locale = Object.assign(this.locale, Hungarian);        
        break;

      case 'ro':
        this.locale = Object.assign(this.locale, Romanian);        
        break;

      case 'it':
        this.locale = Object.assign(this.locale, Italian);        
        break;

      // Greek country code is passed with 'el' from the system.
      case 'el':
        this.locale = Object.assign(this.locale, Greek);
        break;
    
      default:
        break;
    }    
	}

  //set the input.value on change
	flatOnChange(dateStr) {
		this.input.setAttribute('value', dateStr);
    const inputElements = this.input.parentElement.querySelectorAll('input');
    const el = inputElements[inputElements.length - 1];
    const event = new CustomEvent('onFlatDatePickerChange', {
      bubbles: true,
      cancelable: true,
      detail: {
        target: el
      }
    });
    window.dispatchEvent(event);
  }
  
  /**
	 * Open the datepicker instance
	 */
	openDatePicker(instance) {
		return (e) => {
      // RBR-430: Datepicker icon is not clickable.
      // Prevent bubling to trigger flatpicker click and hide datepicker.
			e.stopPropagation()
			instance.open();
		};
	}
}
